import { reportNative } from "./bridge";

/**
 * 按钮点击上报
 * @param {Object} data
 *  - page_name	页面名称
 *  - button_name 按钮名称
 */
export function reportClick(data) {
  reportNative({
    event_id: "10012",
    attributes: data,
  });
}

/**
 * 弹窗弹出上报
 * @param {Object} data
 *  - page_name	页面名称
 *  - pop_name	弹窗名称
 */
export function reportPop(data) {
  reportNative({
    event_id: "10013",
    attributes: data,
  });
}

/**
 * 弹窗点击上报
 * @param {Object} data
 *  - page_name	页面名称
 *  - pop_name	弹窗名称
 *  - button_name 按钮名称
 */
export function reportPopClick(data) {
  console.log("reportPopClick: ", data);
  reportNative({
    event_id: "10014",
    attributes: data,
  });
}
